import App from './App.vue';

export default {
  path: '/CDS_VF_NoticeList',
  name: 'CDS_VF_NoticeList',
  component: App,
  meta: {
    pageProperty: {
      title: 'お知らせ',
      controller: 'CDS_CTR_NoticeList',
    },
  },
};
